import { LinkPreview } from "@/components/ui/FileDisplay/FileDisplayContent/LinkDisplay/LinkPreview";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import LoadingSpinner from "@/components/LoadingSpinner";

interface FilePreviewDialogProps {
  previewFileId: string | null;
  previewFileName: string;
  previewBlobUrl: string | null;
  isLoadingPreview: boolean;
  onClose: () => void;
}

const getFileTypeInfo = (filename: string): { type: string; icon: string; label: string } => {
  if (filename.toLowerCase().endsWith(".pdf")) {
    return { type: "pdf", icon: "FileText", label: "PDF Document" };
  }
  return { type: "link", icon: "ExternalLink", label: "Web Link" };
};

export const FilePreviewDialog: React.FC<FilePreviewDialogProps> = ({
  previewFileId,
  previewFileName,
  previewBlobUrl,
  isLoadingPreview,
  onClose,
}) => {
  if (!previewFileId) {
    return null;
  }

  const fileTypeInfo = getFileTypeInfo(previewFileName);

  return (
    <Dialog open={!!previewFileId} onOpenChange={onClose}>
      <DialogContent className="flex max-h-[90vh] max-w-6xl flex-col overflow-auto">
        <DialogHeader>
          <DialogTitle>Preview: {previewFileName}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 p-4">
          {(() => {
            if (isLoadingPreview) {
              return (
                <div className="flex h-[70vh] items-center justify-center">
                  <LoadingSpinner size={8} />
                  <p className="ml-2 text-sm text-gray-500">Generating preview URL...</p>
                </div>
              );
            }

            if (previewBlobUrl) {
              return (
                <LinkPreview
                  data={previewBlobUrl}
                  detectedFile={{
                    type: fileTypeInfo.type as "pdf" | "text" | "json" | "csv" | "link" | "unknown",
                    linkTypeInfo: fileTypeInfo,
                  }}
                />
              );
            }

            return (
              <div className="flex h-[70vh] items-center justify-center text-gray-500">
                <div className="text-center">
                  <p className="mb-2">Preview Unavailable</p>
                  <p className="text-sm text-gray-400">
                    This file was uploaded outside of PromptLayer. To view a preview, please
                    re-upload the file to PromptLayer.
                  </p>
                </div>
              </div>
            );
          })()}
        </div>
      </DialogContent>
    </Dialog>
  );
};
